import React from "react";
import "./image.scss";

const Image = ({ src, alt, imgStyle, onClick, isBanner }) => {
  return (
    <div className={isBanner ? "banner-img" : "style-image"}>
      <img src={src} alt={alt} className={imgStyle} onClick={onClick} />
    </div>
  );
};

export default Image;
